import React, { useState } from 'react';
import './contactUs.css'; // أضف التنسيق الخاص بك هنا

function ContactUs() {
  // حالة لتتبع ما إذا كان الـ iframe قد تم تحميله أم لا
  const [loading, setLoading] = useState(true);

  // وظيفة لتغيير حالة التحميل عند اكتمال تحميل الـ iframe
  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <section className="contactSection">
      <div className="container contactContainer">
        <div className="row contact-content">
          <div className="col-md-12 col-sm-12 form-section">
            <div className="contact-form">

              {loading ? (
                <div className="loading-message text-center">
                  <p>جاري التحميل...</p>
                  <div className="spinner-border spinner" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : null}



              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSct9227h_EUjOspNA3yZmz64-4ErBRv0FWvvmXX0tzw30Un_Q/viewform?usp=header"
                width="100%"
                height="600"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                className="survey-iframe"
                onLoad={handleIframeLoad} // عندما يكتمل تحميل الـ iframe، قم بتغيير حالة التحميل
                style={{ display: loading ? 'none' : 'block' }} // إخفاء الـ iframe حتى يتم تحميله
                title="نموذج استبيان عبر Google Forms" 
              >
                جاري التحميل...
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
